// Quick choices for "remind me about this ticket", and how to word a due time.
const at9 = (date) => { const d = new Date(date); d.setHours(9, 0, 0, 0); return d; };

// Next occurrence of a weekday (0 = Sunday ... 6 = Saturday), strictly after today.
const nextWeekday = (now, weekday) => {
  const d = new Date(now);
  d.setDate(d.getDate() + (((weekday - d.getDay() + 7) % 7) || 7));
  return at9(d);
};

export const followUpPresets = (now = new Date()) => {
  const inOneHour = new Date(now.getTime() + 60 * 60 * 1000);
  inOneHour.setSeconds(0, 0);
  const tomorrow = new Date(now); tomorrow.setDate(tomorrow.getDate() + 1);
  const inThreeDays = new Date(now); inThreeDays.setDate(inThreeDays.getDate() + 3);
  return [
    { key: 'hour', label: 'In 1 hour', at: inOneHour },
    { key: 'tomorrow', label: 'Tomorrow 9am', at: at9(tomorrow) },
    { key: 'three', label: 'In 3 days', at: at9(inThreeDays) },
    { key: 'monday', label: 'Next Monday', at: nextWeekday(now, 1) }
  ];
};

// "Today 14:30", "Tomorrow 09:00", "Mon 2 Nov, 09:00"; "Overdue" when past.
export const describeDue = (value, now = new Date()) => {
  const due = new Date(value);
  if (Number.isNaN(due.getTime())) return { label: '', overdue: false };
  const time = due.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  const startOf = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const dayDiff = Math.round((startOf(due) - startOf(now)) / 86400000);
  const overdue = due.getTime() <= now.getTime();
  let label;
  if (dayDiff === 0) label = `Today ${time}`;
  else if (dayDiff === 1) label = `Tomorrow ${time}`;
  else if (dayDiff === -1) label = `Yesterday ${time}`;
  else label = `${due.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })}, ${time}`;
  return { label, overdue };
};

// <input type="datetime-local"> wants local "YYYY-MM-DDTHH:mm".
export const toLocalInput = (date) => {
  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
